export const STYLES = {
  ERROR_MODAL: {
    LAYOUT:
      'flex flex-col bg-bw00 h-[444px] min-w-[456px] justify-between items-center pb-[50px] pt-[58px] px-[40px] rounded-[8px]',
    TITLE: 'mb-[15px] text-bw08 font-metricRSemibold text-[22px]',
    SUBTITLE: 'text-bw07 font-metricR text-[16px]',
    BUTTON: 'max-w-[254px] w-full rounded-[3px] text-[14px]',
  },
};
